<template>
  <div>
    <div class="qp-bg com-news">
      <div class="txtMarquee-left">
        <div class="block">
          <div class="iconfont icon-tongzhi2"></div>
          <p>
            <font style="vertical-align: inherit"><font style="vertical-align: inherit">{{$t('index.announcement')}}</font></font>
          </p>
          <div id="memberLatestAnnouncement" @click="$parent.goNav('/message?type=1')">
            <marquee scrollamount="8" scrolldelay="100" direction="left" onclick="hotNewsHistory()" onmouseover="this.stop();" onmouseout="this.start();"
              ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{$t('index.official')}} </font></font></marquee
            >
          </div>
        </div>
      </div>
    </div>
    <div id="com-content" class="com-con" >
      <div class="wrapper">
        <div class="pokGameList wrapper">
          <ul class="clearfix" id="jChessGameListArea">
            <li v-for="(item, index) in gameList" :key="index" v-if="item.app_state == 1">
              <a class="j-mz" @click="$parent.openGamePage(item.platform_name, item.game_code, '')" target="_blank" data-id="890" data-platform="KYCHESS" data-tag="NEW" data-type="890">
                <img   class="lazy" :src="`/static/image/joker/${item.platform_name}.jpg`" />
                <div class="mask-title">
                  <p>
                    <font style="vertical-align: inherit"
                      ><font style="vertical-align: inherit">{{ item.name }}</font></font
                    >
                  </p>
                  <span class="chess-btn"
                    ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{$t('index.playgames')}}</font></font></span
                  >
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
 
  </div>
</template>
<script>
export default {
  name: 'joker',
  data() {
    return {
      gameList: [],
           imgList: {
        bbin: { img: '/static/image/image/bbin.png' },
        bg: { img: '/static/image/ebg.png'},
        datqp: { img: '/static/image/datqp.png' },
        fg: { img: '/static/image/dzfg.png', hover: '/static/image/fg-hover.png' },
        hlgame: { img: '/static/image/qphl.jpg', hover: '/static/image/hg-hover.png' },
        kx: { img: '/static/image/qpkx.jpg', hover: '/static/image/kx-hover.png' },
        kx2: { img: '/static/image/qpkx2.jpg', hover: '/static/image/kx2-hover.png' },
        leg: { img: '/static/image/ky-hall.jpg', hover: '/static/image/ky-hover.png' },
        obgqp: { img: '/static/image/qpap.jpg', hover: '/static/image/ob-hover.png'},
        sy: { img: '/static/image/qpsy.jpg', hover: '/static/image/syqp-hover.png' },
        vg: { img: '/static/image/qpvg.jpg', hover: '/static/image/vg-hover.png' },
        xsj: { img: '/static/image/qpxsj.jpg', hover: '/static/image/xsj-hover.png' },
        ly: { img: '/static/image/qply.jpg', hover: '/static/image/leg-hover.png' },
      },
    };
  },
  created() {
    let that = this;
    that.getGameList();
  },
  methods: {
    getGameList() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun.get('/api/game/list', { category: 'joker' }).then(res => {
        if (res.code == 200) {
          that.gameList = res.data;
          that.$parent.hideLoading();
        }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/fishGameLobby.css';
.pokGameList li {
    height: 250px;
    width: 250px;
    margin: 0 23px 36px 0;
    text-align: center;
    background: #393c41;
    float: left;
    overflow: hidden;
    -webkit-transition: all .3s;
    transition: all .3s;
}
.pokGameList li:nth-child(3), .pokGameList li:nth-child(4n+3) {
        margin: 0 23px 36px 0;

}
#app{
  background: none!important;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/joker.vue